import angular from 'angular'

import listCtrl from './list.controller'
import listRoutes from './list.routes'
import listRun from './list.run'

const name = 'routingConsultList'

angular.module(name, [])
  .controller('listCtrl', listCtrl)
  .config(listRoutes)
  .run(listRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/list/list.module.js